import { render, staticRenderFns } from "./ApplicationContentTopAlerts.vue?vue&type=template&id=81969dba&scoped=true&"
import script from "./ApplicationContentTopAlerts.vue?vue&type=script&lang=js&"
export * from "./ApplicationContentTopAlerts.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationContentTopAlerts.vue?vue&type=style&index=0&id=81969dba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81969dba",
  null
  
)

export default component.exports